import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:api-docs` from `@backstage/plugin-api-docs` with a
 * Tailwind/shadcn page (ADR-0012). The stock `DefaultApiExplorerPage` is a
 * Material-UI filter rail (kind/type/owner/lifecycle/tag pickers) plus a
 * dense `CatalogTable` — same drift from the rest of the portal as the
 * notifications and catalog overrides.
 *
 * Aliasing the plugin's own route ref keeps `useRouteRef`/the `/api-docs`
 * sidebar entry pointing here, and `noHeader` suppresses the `PluginHeader`
 * the blueprint would otherwise stack above the page's own branded `Header`.
 */
export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/api-docs',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'api-docs.root' }),
        loader: () =>
          import('./VivictaApiExplorerPage').then(m => (
            <PageErrorBoundary title="APIs">
              <m.VivictaApiExplorerPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
